import { configAvailabilityProduct } from '../../../module/config';

export const showAvailabilityLater = (quantityAvailabilityLater: number, quantityAvailabilityNow: number): boolean => {
  return (
    (!!quantityAvailabilityLater &&
      quantityAvailabilityNow < configAvailabilityProduct.minAvailabilityNow &&
      quantityAvailabilityNow < quantityAvailabilityLater) ||
    (!quantityAvailabilityNow && !!quantityAvailabilityLater)
  );
};
